import { render, staticRenderFns } from "./EventDetailErrorMessagesStory.vue?vue&type=template&id=ff4e1f0e&"
import script from "./EventDetailErrorMessagesStory.vue?vue&type=script&lang=ts&"
export * from "./EventDetailErrorMessagesStory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports